import { Instance, types } from 'mobx-state-tree';
import { ComponentField } from '../../../../infrastructure/dynamic-forms/ComponentField';

export const EnrollmentModuleForm = types.model('EnrollmentModuleForm', {
  formFields: types.array(ComponentField)
});
export type EnrollmentModuleForm = Instance<typeof EnrollmentModuleForm>;
